import { FC } from 'react';
import { InvoiceSubmission } from './types';
import { InvoiceDetailEditableView } from './InvoiceDetailEditableView';
import { InvoiceDetailReadonlyView } from './InvoiceDetailReadonlyView';

type InvoiceDetailViewProps = {
  invoice: InvoiceSubmission;
  onBack: () => void;
};

const InvoiceDetailView: FC<InvoiceDetailViewProps> = ({ invoice, onBack }) =>
  invoice.status === 'Fix' ? (
    <InvoiceDetailEditableView invoice={invoice} onBack={onBack} />
  ) : (
    <InvoiceDetailReadonlyView invoice={invoice} onBack={onBack} />
  );

export default InvoiceDetailView;
